import { FetchArgs, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import server from "config/server";
import { getCsrfToken, getAuthToken } from "utils/api-utils";

export interface BaseQueryExtraOptions {
  response: {
    status: number;
    statusText: string;
    ok: boolean;
    bodyUsed: boolean;
    headers: Headers;
  };
}

export const baseQuery = retry(
  async (
    args: string | FetchArgs,
    api,
    extraOptions: BaseQueryExtraOptions,
  ) => {
    const csrfToken = getCsrfToken();
    const authToken = getAuthToken();

    const result = await fetchBaseQuery({
      baseUrl: `${server.HOST}api/v1/`,
      prepareHeaders: (headers) => {
        if (csrfToken) {
          headers.set("X-CSRFToken", csrfToken);
        }
        if (authToken) {
          headers.set("Authorization", `Token ${authToken}`);
        }
        headers.set("Content-Type", "application/json");
        return headers;
      },
      credentials: "include",
    })(args, api, extraOptions);

    // if any error, need to try to call this api again
    if (
      Number(result.error?.status) < 500 &&
      Number(result.error?.status) >= 400
    ) {
      retry.fail(result.error);
    }
    return result;
  },
  {
    maxRetries: 2,
  },
);
